import { render } from "./SupportPanel.vue?vue&type=template&id=282bd881&ts=true"
import script from "./SupportPanel.vue?vue&type=script&lang=ts"
export * from "./SupportPanel.vue?vue&type=script&lang=ts"

import "./SupportPanel.vue?vue&type=style&index=0&id=282bd881&lang=scss"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__